module.exports = __webpack_public_path__ + "img/arrow-left.392da28c.svg";